import React from 'react'
import {useTranslation} from 'i18n'
import {Paragraph, RoboyuHappy} from 'common/components'
import {useSelector} from 'lib/redux'
import convertUnit from 'lib/unit'
import {GiftShopRobopetActivationTemplate} from '../ActivationTemplate'

export default function GiftShopRobopetActivationProcessing() {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')

  return (
    <GiftShopRobopetActivationTemplate
      backgroundColor="primary_1"
      robopetImg={
        <RoboyuHappy
          width={convertUnit(161)}
          height={convertUnit(174)}
          colorTheme={colorTheme.name}
        />
      }
      title={translate('giftShop:roboyuActivationProcessingHeader')}
      titleColor="primary_5">
      <Paragraph fontSize="m" fontWeight="regular" color="primary_5">
        {translate('giftShop:roboyuActivationProcessingDescription')}
      </Paragraph>
    </GiftShopRobopetActivationTemplate>
  )
}
